export default __webpack_public_path__ + "static/media/logo3.b8ce4a42.png";